// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footerMenuGroup-m__wrapper__26G78","en-wrappper":"footerMenuGroup-m__en-wrappper__2O_mg","footer-menu-item":"footerMenuGroup-m__footer-menu-item__3Ad_V"};